export default __webpack_public_path__ + "static/media/green-gradient-blue2.f31c15c6.png";